import request from "../axios/http";
// 首页
export const HOME = data => {
    return request.post("index/info");
};
// 解决方案 banner
export const SCHEMEBANNER = data => {
    return request.post("solution/banner");
};
// 解决方案列表
export const SCHEMELIST = data => {
    return request.post("solution/lists");
};
// 方案详情
export const SCHEMEDETAIL = data => {
    return request.post("solution/info", data);
};
// 产品展示 banner
export const PRODUCTBANNER = data => {
    return request.post("product/banner");
};
// 产品分类 默认0为全部分类 pid不为0时为某分类 子类
export const PRODUCTCLASS = (data = { pid: 0 }) => {
    return request.post("product/category", data);
};
// 产品列表
export const PRODUCTLIST = data => {
    return request.post("product/lists", data);
};
// 产品列表
export const PRODUCDETAIL = data => {
    return request.post("product/info", data);
};
// 经典案例 banner
export const CASEBANNER = data => {
    return request.post("cases/banner");
};
// 案例列表
export const CASELIST = data => {
    return request.post("cases/lists", data);
};
// 案例详情
export const CASEDETAIL = data => {
    return request.post("cases/info", data);
};
// 新闻中心 banner
export const NEWSBANNER = data => {
    return request.post("news/banner");
};
// 新闻列表
export const NEWSLIST = data => {
    return request.post("news/lists", data);
};
// 新闻详情
export const NEWSDETAIL = data => {
    return request.post("news/info", data);
};
// 关于我们 banner
export const ABOUTBANNER = data => {
    return request.post("about/banner");
};
// 关于我们-发现更多
export const ABOUTBMORE = data => {
    return request.post("about/discover");
};
// 关于我们-公司信息
export const ABOUTINFO = data => {
    return request.post("about/info");
};
